import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    coins: JSON.parse(localStorage.getItem('coins')) || {},
    coinRates: JSON.parse(localStorage.getItem('coin_rate')) || [],
    addresses: JSON.parse(localStorage.getItem('addresses')) || [],
    p2pTrader: JSON.parse(localStorage.getItem('p2ptrader')) || {},
    forex: JSON.parse(localStorage.getItem('forex')) || [],
    stock: JSON.parse(localStorage.getItem('stock')) || [],
}

export const coinSlice = createSlice({
    name: 'coins',
    initialState,
    reducers: {
        setCoins: (state, action) =>{
            state.coins = action.payload;  
            localStorage.setItem('coins', JSON.stringify(state.coins));
        },
        setAddresses: (state, action) =>{
            state.addresses = action.payload;  
            localStorage.setItem('addresses', JSON.stringify(state.addresses));
        },
        setRate: (state, action) =>{
            state.coinRates = action.payload;  
            localStorage.setItem('coin_rate', JSON.stringify(state.coinRates));
        },

        setForex: (state, action) =>{
            state.forex = action.payload;  
            localStorage.setItem('forex', JSON.stringify(state.forex));
        },

        setStock: (state, action) =>{
            state.stock = action.payload;  
            localStorage.setItem('stock', JSON.stringify(state.stock));
        },


        setP2pTrader: (state, action) =>{
            state.p2pTrader = action.payload;  
            localStorage.setItem('p2pTrader', JSON.stringify(state.p2pTrader));
        },
        
    }
})

export const {setCoins, setAddresses, setForex, setStock, setRate, setP2pTrader} = coinSlice.actions;
export default coinSlice.reducer;